import React from "react";
import Load from "../assets/load.gif"
import './BlockPage.scss';


const BlockPage = ({ onLoadingComplete }) => {
    onLoadingComplete(true)
    return (

        <div className="blockPage">

            <div className="blockPage-loading">
                <img src={Load} alt="load" className="blockPage-load" />

                <p className="blockPage-loading-text">К сожалению, доступ к приложению для вас закрыт.</p>
            </div>
        </div>
    );
};

export default BlockPage;
